import { Button, Center, Stack, Text, Title } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";
import { Component, type ErrorInfo, type ReactNode } from "react";

type Props = {
  children: ReactNode;
};

type State = {
  hasError: boolean;
  message: string;
};

/**
 * Catches unhandled render errors so the rest of the app
 * never goes completely blank. Wrap around the RouterProvider.
 */
export class ErrorBoundary extends Component<Props, State> {
  override state: State = { hasError: false, message: "" };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, message: error.message };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    // Sentry is initialised in main.tsx and captures errors automatically
    // via its global handler; no explicit capture needed here.
    console.error("[ErrorBoundary]", error, info.componentStack);
  }

  handleReload = () => {
    this.setState({ hasError: false, message: "" });
    window.location.reload();
  };

  override render() {
    if (this.state.hasError) {
      return (
        <Center mih="100vh">
          <Stack align="center" gap="md" maw={420} ta="center" p="xl">
            <IconAlertTriangle size={48} color="var(--mantine-color-error-5)" />
            <Title order={3}>مشکلی پیش آمد</Title>
            <Text size="sm" c="dimmed">
              یک خطای غیرمنتظره رخ داد. لطفاً صفحه را مجدداً بارگذاری کنید.
            </Text>
            <Button onClick={this.handleReload}>بارگذاری مجدد</Button>
          </Stack>
        </Center>
      );
    }

    return this.props.children;
  }
}
